import { render, staticRenderFns } from "./starshop-common-access-description-column.vue?vue&type=template&id=18bc6cd4"
import script from "./starshop-common-access-description-column.vue?vue&type=script&lang=js"
export * from "./starshop-common-access-description-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports